'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var setItems = function setItems(props) {
	var children = props.children,
	    orientation = props.orientation,
	    styleClasses = props.styleClasses;


	var legacyStylesItem = {
		'margin-top': props.marginTopItem,
		'margin-bottom': props.marginBottomItem,
		'padding-bottom': props.paddingVerticalItem,
		'padding-top': props.paddingVerticalItem,
		'padding-left': props.paddingHorizontalItem,
		'padding-right': props.paddingHorizontalItem
	};

	var getMaxWidth = function getMaxWidth() {
		if (orientation === 'horizontal') {
			var maxWidth = 100 / children.length;
			return {
				'max-width': maxWidth + '%'
			};
		}
	};

	var styleItem = styleClasses.ListItem ? getMaxWidth() : Object.assign({}, legacyStylesItem, getMaxWidth());

	return children.map(function (x, i) {
		return (0, _magicVirtualElement2.default)(
			'li',
			{ key: x.attributes.id + '-' + i, 'class': ['CMS-ListItem CMS-ListItem--' + orientation, styleClasses.Item], 'data-style-attr': 'Item', style: styleItem },
			x
		);
	});
};

var render = function render(_ref) {
	var props = _ref.props;
	var bullet = props.bullet,
	    image = props.image,
	    bulletPosition = props.bulletPosition,
	    styleClasses = props.styleClasses;

	var listStyle = bullet;
	var ordered = false;

	if (bulletPosition !== 'initial') {
		listStyle += ' ' + bulletPosition;
	}

	if (image) {
		listStyle += ' url(\'' + image + '\')';
	}

	var legacyStylesList = {
		'margin-top': props.marginTopList,
		'margin-bottom': props.marginBottomList,
		'padding-bottom': props.paddingVerticalList,
		'padding-top': props.paddingVerticalList,
		'padding-left': props.paddingHorizontalList,
		'padding-right': props.paddingHorizontalList
	};

	var listStyles = {
		'list-style': listStyle
	};

	var styleList = props.styleClasses.List ? listStyles : Object.assign({}, legacyStylesList, listStyles);

	['decimal', 'decimal-leading-zero', 'lower-alpha', 'upper-alpha', 'lower-roman', 'upper-roman'].forEach(function (x) {
		if (bullet === x) {
			ordered = true;
		}
	});

	if (ordered) {
		return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
			'ol',
			{ 'class': ['CMS-List', props.class, styleClasses.List], style: styleList, 'data-style-attr': 'List' },
			setItems(props)
		), props);
	}

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'ul',
		{ 'class': ['CMS-List', props.class, styleClasses.List], style: styleList, 'data-style-attr': 'List' },
		setItems(props)
	), props);
};

exports.default = { render: render };